export const SET_ACTIVE_IUI_CHART = 'SET_ACTIVE_IUI_CHART';
export const SET_IUI_LIST = 'SET_IUI_LIST';
export const UPDATE_IUI_LIST = 'UPDATE_IUI_LIST';
